import React from "react"
import Input from "../form/Input"
 export const Slider = ({
  handleSetMin,
  handleSetMax,
  minValue,
  maxValue,
  minTypeField,
  maxTypeField,
 }) => {

  return (
    <div className="flex flex-row justify-between space-x-4 w-full mb-4">
        <div className="w-1/2">
          <Input 
            className="shadow-md" 
            //onInput={handleSetMin} 
            onChange={handleSetMin} 
            type="number" 
            min={minValue} 
            //ref={minRef}
            max={maxValue} 
            value={minTypeField} 
          />
        </div>
        <div className="w-1/2">
          <Input 
            className="shadow-md" 
            //onInput={handleSetMax} 
            onChange={handleSetMax} 
            type="number" 
            min={minValue} 
            //ref={maxRef} 
            max={maxValue} 
            value={maxTypeField} 
          />
        </div>
    </div>
  )
}
